/*
 * ASTRA BODY JEWELRY - Option sterilisation
 * assets/astra-sterilisation.js
 *
 * Maintient la ligne "Sterilisation" du panier a une quantite egale au
 * nombre de bijoux portant la propriete de sterilisation.
 * Une sterilisation facturee par bijou.
 *
 * SUPPRESSION VOLONTAIRE
 * Retirer la ligne Sterilisation depuis le panier ne suffit pas : les
 * bijoux portent toujours la propriete et la synchronisation la
 * remettrait aussitot. Il faut donc retirer la propriete des bijoux.
 *
 * Cette intention est detectee en INSPECTANT LA REQUETE envoyee au
 * panier : on ne conclut a une suppression que si l'on voit passer un
 * ordre de mise a zero visant la ligne Sterilisation. Une precedente
 * version deduisait l'intention d'une quantite memorisee dans le
 * navigateur ; cette memoire survivait aux tests et faisait retirer
 * l'option au moment meme ou le client venait de la cocher. Ne pas
 * revenir a une detection par memoire : l'etat du panier peut changer
 * dans un autre onglet ou cote serveur.
 *
 * Configuration injectee par snippets/astra-sterilisation.liquid.
 */

(function () {
  'use strict';

  var CONFIG = window.AstraSterilisation || {};
  var VARIANT_ID = parseInt(CONFIG.variantId, 10);
  var PROPRIETE = CONFIG.propriete || 'Stérilisation';
  var VALEUR = CONFIG.valeur || 'Oui';

  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---- Fenetre d'information (toujours active) ---- */
  document.addEventListener('click', function (event) {
    var ouvrir = event.target.closest('[data-astra-ster-open]');
    if (ouvrir) {
      var cible = document.getElementById(ouvrir.getAttribute('data-astra-ster-open'));
      if (cible && typeof cible.showModal === 'function') {
        event.preventDefault();
        cible.showModal();
      }
      return;
    }

    var fermer = event.target.closest('[data-astra-ster-close]');
    if (fermer) {
      var parent = fermer.closest('dialog');
      if (parent) parent.close();
      return;
    }

    if (event.target.tagName === 'DIALOG' && event.target.open) {
      event.target.close();
    }
  });

  if (!VARIANT_ID) return;

  /* Derniere position connue de la ligne Sterilisation, servant a
     reconnaitre un ordre de suppression qui la vise. */
  var ligneConnue = null; /* { index, key } */
  var suppressionVoulue = false;

  var enCours = false;
  var relancer = false;

  function getCart() {
    return fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function poster(url, payload) {
    return fetch(racine + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function estCoche(item) {
    var props = item.properties || {};
    var valeur = props[PROPRIETE];
    return !!valeur && String(valeur).trim() === VALEUR;
  }

  function compterBijoux(cart) {
    return (cart.items || []).reduce(function (total, item) {
      if (item.variant_id === VARIANT_ID) return total;
      return estCoche(item) ? total + item.quantity : total;
    }, 0);
  }

  function trouverLigne(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === VARIANT_ID) {
        return { index: i + 1, quantite: items[i].quantity, key: items[i].key };
      }
    }
    return null;
  }

  function rafraichir() {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('astra:sterilisation:updated', { bubbles: true }));
  }

  /*
   * Retire la propriete de tous les bijoux qui la portent.
   * On refait un cart.js entre chaque appel : modifier les proprietes
   * d'une ligne peut la fusionner avec une autre et decaler les index.
   */
  function retirerPropriete() {
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var cible = null;

      for (var i = 0; i < items.length; i++) {
        if (items[i].variant_id !== VARIANT_ID && estCoche(items[i])) {
          cible = { index: i + 1, item: items[i] };
          break;
        }
      }

      if (!cible) return false;

      var nouvelles = {};
      var anciennes = cible.item.properties || {};
      for (var cle in anciennes) {
        if (cle !== PROPRIETE) nouvelles[cle] = anciennes[cle];
      }

      return poster('cart/change.js', {
        line: cible.index,
        quantity: cible.item.quantity,
        properties: nouvelles
      }).then(function () {
        return retirerPropriete();
      }).then(function () {
        return true;
      });
    });
  }

  function synchroniser() {
    if (enCours) { relancer = true; return Promise.resolve(); }
    enCours = true;

    return getCart()
      .then(function (cart) {
        var voulue = compterBijoux(cart);
        var ligne = trouverLigne(cart);
        ligneConnue = ligne ? { index: ligne.index, key: ligne.key } : null;

        if (suppressionVoulue) {
          suppressionVoulue = false;
          if (voulue > 0) return retirerPropriete();
          return false;
        }

        if (!ligne && voulue > 0) {
          return poster('cart/add.js', { items: [{ id: VARIANT_ID, quantity: voulue }] })
            .then(function () { return true; });
        }

        if (ligne && ligne.quantite !== voulue) {
          return poster('cart/change.js', { line: ligne.index, quantity: voulue })
            .then(function () { return true; });
        }

        return false;
      })
      .then(function (aChange) { if (aChange) rafraichir(); })
      .catch(function () { /* le panier reste utilisable */ })
      .then(function () {
        enCours = false;
        if (relancer) { relancer = false; setTimeout(synchroniser, 60); }
      });
  }

  /* ---- Lecture des requetes envoyees au panier ---- */
  var ROUTES = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function estRoutePanier(url) {
    if (!url) return false;
    var s = String(url);
    for (var i = 0; i < ROUTES.length; i++) {
      if (s.indexOf(ROUTES[i]) !== -1) return true;
    }
    return false;
  }

  function enObjet(corps) {
    if (!corps) return null;
    try {
      if (typeof corps === 'string') {
        var texte = corps.trim();
        if (texte.charAt(0) === '{') return JSON.parse(texte);
        var params = new URLSearchParams(texte);
        var o = {};
        params.forEach(function (v, k) { o[k] = v; });
        return o;
      }
      if (typeof FormData !== 'undefined' && corps instanceof FormData) {
        var f = {};
        corps.forEach(function (v, k) { f[k] = v; });
        return f;
      }
    } catch (e) {}
    return null;
  }

  function viseLaSterilisation(cle) {
    if (cle == null) return false;
    var s = String(cle);
    if (s === String(VARIANT_ID)) return true;
    if (ligneConnue) {
      if (s === String(ligneConnue.index)) return true;
      if (ligneConnue.key && s === String(ligneConnue.key)) return true;
    }
    return false;
  }

  function estZero(v) {
    return v === 0 || v === '0';
  }

  /*
   * Une suppression volontaire se reconnait a un ordre de mise a zero
   * visant explicitement la ligne Sterilisation, jamais a une deduction
   * sur l'etat du panier.
   */
  function analyserRequete(url, corps) {
    var o = enObjet(corps);
    if (!o) return;

    if (String(url).indexOf('/cart/change') !== -1) {
      if (estZero(o.quantity) && (viseLaSterilisation(o.line) || viseLaSterilisation(o.id))) {
        suppressionVoulue = true;
      }
      return;
    }

    if (String(url).indexOf('/cart/update') !== -1 && o.updates) {
      var maj = o.updates;
      if (typeof maj === 'object') {
        for (var cle in maj) {
          if (estZero(maj[cle]) && viseLaSterilisation(cle)) {
            suppressionVoulue = true;
            return;
          }
        }
      }
    }
  }

  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var options = arguments[1];
    if (url && typeof url === 'object' && url.url) url = url.url;

    if (estRoutePanier(url) && options) analyserRequete(url, options.body);

    var resultat = fetchOriginal.apply(this, arguments);
    if (estRoutePanier(url)) {
      resultat.then(function (reponse) {
        if (reponse && reponse.ok) setTimeout(synchroniser, 80);
        return reponse;
      }).catch(function () {});
    }
    return resultat;
  };

  var openOriginal = XMLHttpRequest.prototype.open;
  var sendOriginal = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (methode, url) {
    this.__astraUrlPanier = estRoutePanier(url) ? String(url) : null;
    return openOriginal.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (corps) {
    if (this.__astraUrlPanier) {
      analyserRequete(this.__astraUrlPanier, corps);
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) setTimeout(synchroniser, 80);
      });
    }
    return sendOriginal.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', synchroniser);
  } else {
    synchroniser();
  }

  window.AstraSterilisation = window.AstraSterilisation || {};
  window.AstraSterilisation.sync = synchroniser;
})();
